export var ProductQueryParam;
(function (ProductQueryParam) {
    ProductQueryParam["EXTRAS"] = "EXTRAS";
    ProductQueryParam["FLIGHT_AIRLINE_CODES"] = "FLIGHT_AIRLINE_CODES";
    ProductQueryParam["FLIGHT_ARRIVAL_AIRPORT_CODES"] = "FLIGHT_ARRIVAL_AIRPORT_CODES";
    ProductQueryParam["FLIGHT_DEPARTURE_AIRPORT_CODES"] = "FLIGHT_DEPARTURE_AIRPORT_CODES";
    ProductQueryParam["FLIGHT_DEPARTURE_AIRPORT_GROUPS"] = "FLIGHT_DEPARTURE_AIRPORT_GROUPS";
    ProductQueryParam["FLIGHT_STOP_OVER_MAX"] = "FLIGHT_STOP_OVER_MAX";
    ProductQueryParam["HOTEL_ATTRIBUTES"] = "HOTEL_ATTRIBUTES";
    ProductQueryParam["HOTEL_BOARD_CODES"] = "HOTEL_BOARD_CODES";
    ProductQueryParam["HOTEL_BOARD_GROUPS"] = "HOTEL_BOARD_GROUPS";
    ProductQueryParam["HOTEL_CATEGORY"] = "HOTEL_CATEGORY";
    ProductQueryParam["HOTEL_CHAIN"] = "HOTEL_CHAIN";
    ProductQueryParam["HOTEL_CODES"] = "HOTEL_CODES";
    ProductQueryParam["HOTEL_GLOBAL_TYPES"] = "HOTEL_GLOBAL_TYPES";
    ProductQueryParam["HOTEL_LOCATION"] = "HOTEL_LOCATION";
    ProductQueryParam["HOTEL_LOCATION_CITY_CODES"] = "HOTEL_LOCATION_CITY_CODES";
    ProductQueryParam["HOTEL_LOCATION_CITY_NAME"] = "HOTEL_LOCATION_CITY_NAME";
    ProductQueryParam["HOTEL_LOCATION_COUNTRY_CODES"] = "HOTEL_LOCATION_COUNTRY_CODES";
    ProductQueryParam["HOTEL_LOCATION_REGION_CODES"] = "HOTEL_LOCATION_REGION_CODES";
    ProductQueryParam["HOTEL_LOCATION_REGION_NAME"] = "HOTEL_LOCATION_REGION_NAME";
    ProductQueryParam["HOTEL_NAME"] = "HOTEL_NAME";
    ProductQueryParam["HOTEL_PRODUCT_CODES"] = "HOTEL_PRODUCT_CODES";
    ProductQueryParam["HOTEL_PROVIDERS"] = "HOTEL_PROVIDERS";
    ProductQueryParam["HOTEL_RATING_CATERING"] = "HOTEL_RATING_CATERING";
    ProductQueryParam["HOTEL_RATING_COUNT"] = "HOTEL_RATING_COUNT";
    ProductQueryParam["HOTEL_RATING_HOTEL"] = "HOTEL_RATING_HOTEL";
    ProductQueryParam["HOTEL_RATING_LOCATION"] = "HOTEL_RATING_LOCATION";
    ProductQueryParam["HOTEL_RATING_OVERALL"] = "HOTEL_RATING_OVERALL";
    ProductQueryParam["HOTEL_RATING_ROOM"] = "HOTEL_RATING_ROOM";
    ProductQueryParam["HOTEL_RATING_SERVICE"] = "HOTEL_RATING_SERVICE";
    ProductQueryParam["HOTEL_RATING_SPORT"] = "HOTEL_RATING_SPORT";
    ProductQueryParam["HOTEL_RATING_TOTAL"] = "HOTEL_RATING_TOTAL";
    ProductQueryParam["HOTEL_RECOMMENDATIONS_BEACH_HOLIDAY"] = "HOTEL_RECOMMENDATIONS_BEACH_HOLIDAY";
    ProductQueryParam["HOTEL_RECOMMENDATIONS_BUSINESS_TRIP"] = "HOTEL_RECOMMENDATIONS_BUSINESS_TRIP";
    ProductQueryParam["HOTEL_RECOMMENDATIONS_CITY_BREAK"] = "HOTEL_RECOMMENDATIONS_CITY_BREAK";
    ProductQueryParam["HOTEL_RECOMMENDATIONS_COUPLES"] = "HOTEL_RECOMMENDATIONS_COUPLES";
    ProductQueryParam["HOTEL_RECOMMENDATIONS_FAMILY"] = "HOTEL_RECOMMENDATIONS_FAMILY";
    ProductQueryParam["HOTEL_RECOMMENDATIONS_FRIENDS"] = "HOTEL_RECOMMENDATIONS_FRIENDS";
    ProductQueryParam["HOTEL_RECOMMENDATIONS_SINGLE"] = "HOTEL_RECOMMENDATIONS_SINGLE";
    ProductQueryParam["HOTEL_RECOMMENDATIONS_TOTAL"] = "HOTEL_RECOMMENDATIONS_TOTAL";
    ProductQueryParam["HOTEL_RECOMMENDATIONS_WELLNESS"] = "HOTEL_RECOMMENDATIONS_WELLNESS";
    ProductQueryParam["HOTEL_ROOM_ATTRIBUTES"] = "HOTEL_ROOM_ATTRIBUTES";
    ProductQueryParam["HOTEL_ROOM_BOOKING_CODES"] = "HOTEL_ROOM_BOOKING_CODES";
    ProductQueryParam["HOTEL_ROOM_CODES"] = "HOTEL_ROOM_CODES";
    ProductQueryParam["HOTEL_ROOM_GROUPS"] = "HOTEL_ROOM_GROUPS";
    ProductQueryParam["HOTEL_ROOM_VIEW_CODES"] = "HOTEL_ROOM_VIEW_CODES";
    ProductQueryParam["HOTEL_QUALIFIERS"] = "HOTEL_QUALIFIERS";
    ProductQueryParam["OPTIONS"] = "OPTIONS";
    ProductQueryParam["PRICE_MAX"] = "PRICE_MAX";
    ProductQueryParam["PRICE_MIN"] = "PRICE_MIN";
    ProductQueryParam["PRODUCT_GROUPS"] = "PRODUCT_GROUPS";
    ProductQueryParam["RAIL_TRAVEL_CLASS"] = "RAIL_TRAVEL_CLASS";
    ProductQueryParam["RAIL_DEPARTURE_STATION_ID"] = "RAIL_DEPARTURE_STATION_ID\"";
    ProductQueryParam["TOUR_OPERATOR_CODES"] = "TOUR_OPERATOR_CODES";
    ProductQueryParam["TRAVELLERS_ADULTS"] = "TRAVELLERS_ADULTS";
    ProductQueryParam["TRAVELLERS_CHILDREN_AGE"] = "TRAVELLERS_CHILDREN_AGE";
    ProductQueryParam["TRAVELLERS_CHILDREN_DATE_OF_BIRTH"] = "TRAVELLERS_CHILDREN_DATE_OF_BIRTH";
    ProductQueryParam["TRAVEL_PERIOD_DEPARTURE_DATE"] = "TRAVEL_PERIOD_DEPARTURE_DATE";
    ProductQueryParam["TRAVEL_PERIOD_EXACT_DEPARTURE_DATE"] = "TRAVEL_PERIOD_EXACT_DEPARTURE_DATE";
    ProductQueryParam["TRAVEL_PERIOD_PREFERRED_DEPARTURE_DATE"] = "TRAVEL_PERIOD_PREFERRED_DEPARTURE_DATE";
    ProductQueryParam["TRAVEL_PERIOD_DEPARTURE_DATE_OFFSET"] = "TRAVEL_PERIOD_DEPARTURE_DATE_OFFSET";
    ProductQueryParam["TRAVEL_PERIOD_DEPARTURE_DATE_POST_OFFSET"] = "TRAVEL_PERIOD_DEPARTURE_DATE_POST_OFFSET";
    ProductQueryParam["TRAVEL_PERIOD_DEPARTURE_DATE_PRE_OFFSET"] = "TRAVEL_PERIOD_DEPARTURE_DATE_PRE_OFFSET";
    ProductQueryParam["TRAVEL_PERIOD_DEPARTURE_DAYS"] = "TRAVEL_PERIOD_DEPARTURE_DAYS";
    ProductQueryParam["TRAVEL_PERIOD_DEPARTURE_TIME_MAX"] = "TRAVEL_PERIOD_DEPARTURE_TIME_MAX";
    ProductQueryParam["TRAVEL_PERIOD_DEPARTURE_TIME_MIN"] = "TRAVEL_PERIOD_DEPARTURE_TIME_MIN";
    ProductQueryParam["TRAVEL_PERIOD_RETURN_DATE"] = "TRAVEL_PERIOD_RETURN_DATE";
    ProductQueryParam["TRAVEL_PERIOD_RETURN_DATE_OFFSET"] = "TRAVEL_PERIOD_RETURN_DATE_OFFSET";
    ProductQueryParam["TRAVEL_PERIOD_RETURN_DATE_PRE_OFFSET"] = "TRAVEL_PERIOD_RETURN_DATE_PRE_OFFSET";
    ProductQueryParam["TRAVEL_PERIOD_RETURN_DATE_POST_OFFSET"] = "TRAVEL_PERIOD_RETURN_DATE_POST_OFFSET";
    ProductQueryParam["TRAVEL_PERIOD_RETURN_DAYS"] = "TRAVEL_PERIOD_RETURN_DAYS";
    ProductQueryParam["TRAVEL_PERIOD_RETURN_TIME_MAX"] = "TRAVEL_PERIOD_RETURN_TIME_MAX";
    ProductQueryParam["TRAVEL_PERIOD_RETURN_TIME_MIN"] = "TRAVEL_PERIOD_RETURN_TIME_MIN";
    ProductQueryParam["TRAVEL_PERIOD_DURATION"] = "TRAVEL_PERIOD_DURATION";
    ProductQueryParam["TRIP_TYPES"] = "TRAVEL_PERIOD_DEPARTURE_DATE";
})(ProductQueryParam || (ProductQueryParam = {}));
